AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "QuestLevel");

AoPS.Alcumus.Models.QuestLevel = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var AlcUtils = AoPS.Alcumus.Utils;
	var AlcMBase = AoPS.Alcumus.Models.Base;

	// Note that there is only one of these models per quest id + level pair.
	// These are always owned by a quest model collection, so the id is the level.
	return AlcMBase.BaseModel.extend({
		id_attribute: "level",
		defaults: {
			level: 0, // Redundant with the id, but much more readable
			user_quest_id: 0,
			alias: "",
			name: "",
			description: "",
			users_completed: 0,
			available_at: "", // For the assigned quest
			finished_at: "", // For the last completion
			is_assigned: false,
			is_completed: false,
			is_failed: false,
			xp_bonus: 0,
			progress: "",
		},
		/** Additional attributes:
			user: User model owning this one; guaranteed to be set
			quest: Quest model owning this one; guaranteed to be set
		*/

		// Note: list also used by back-end
		level_name_suffixes: [
			"I",
			"II",
			"III",
			"IV",
			"V",
			"VI",
			"VII",
			"VIII",
			"IX",
			"X",
		],

		// Any complicated unpacking logic can be found in the Quest model's unpack
		// method.

		requestLoad: function (callback, context) {
			this.get("user").requestQuestsLoad(callback, context);
		},

		// Get string with compact list of all previously completed levels of
		// this quest.
		getPreviousNamesString: function () {
			var level = this.get("level");
			if (level <= 1) {
				return null;
			}

			return (
				this.getBaseName() +
				" " +
				this.level_name_suffixes.slice(0, level - 1).join(", ")
			);
		},

		getNameForLevel: function (level) {
			var name = this.get("name");
			if (this.get("level_count") <= 1) {
				return name;
			}

			var new_suffix = this.level_name_new_suffixes[level];
			if (!new_suffix) {
				return name;
			}

			var last_space = name.lastIndexOf(" ");
			var base_name = last_space > -1 ? name.slice(0, last_space) : name;
			return base_name + " " + new_suffix;
		},

		getBaseName: function () {
			var name = this.get("name");
			if (this.get("level_count") <= 1) {
				return name;
			}
			var last_space = name.lastIndexOf(" ");
			return last_space > -1 ? name.slice(0, last_space) : name;
		},

		getBadgeData: function () {
			return AlcUtils.getBadgeData(
				this.get("quest").id,
				this.get("level"),
				this.get("quest").get("is_achievement")
			);
		},

		abandon: function (callback, context) {
			// Repeated request check
			if (this.is_abandoning) {
				return;
			}
			this.is_abandoning = true;

			callback = LoadUtils.makeCallback(callback, context);
			AlcMBase.ajax.run(
				"abandon_quest",
				{
					user_id: this.get("user").id,
					user_quest_id: this.get("user_quest_id"),
				},
				_.bind(function (ok, data) {
					this.is_abandoning = false;
					if (!ok) {
						return callback(ok, data);
					}
					this.set("is_assigned", false);
					this.get("user").unpack(data.response.user);
				}, this)
			);
		},
	});
})();
